module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/warsztaty-herbaty-sencha-6bde71b11acff9d6680f1a4ceb7200f7.jpg";